module.exports = __webpack_public_path__ + "static/profile-8f753bc204720b85481385dce6bd857e.jpg";